<script lang="ts">
  import GridLines from '$lib/components/GridLines.svelte';
  import { hatchStyle45 } from '$lib/styles/hatch';
  import { sortedPosts } from '$lib/data/posts';

  const latestPost = sortedPosts.length > 0 ? sortedPosts[0] : null;
</script>

<section class="hero bg-[#F9F9F4] relative" style={hatchStyle45}>
  <GridLines variant="light" />

  <!-- Hero copy + CTAs -->
  <div class="relative flex flex-col items-center text-center max-w-[1100px] mx-auto pt-20 lg:pt-24 pb-16 lg:pb-20 px-8">
    <h1 class="font-display text-[#020202] tracking-[-0.045em] w-full">
      <span class="block font-[280] text-[40px] md:text-[56px] lg:text-[68px] leading-[0.95] text-[#020202]/55">
        Bring the AI in.
      </span>
      <span class="block font-[480] text-[56px] md:text-[80px] lg:text-[98px] leading-[0.94] text-[#020202] mt-1 lg:mt-2">
        Make it your own.
      </span>
    </h1>

    <p class="font-body font-light text-[16px] lg:text-[18px] leading-[1.5] tracking-[-0.01em] text-[#3a3a3a] max-w-[640px] mt-9 lg:mt-11">
      Deploy a complete AI foundation into your cloud in 30 minutes. Connect your data, build agents for your workflows, shape AI to how your business actually works — without the $500K build.
    </p>

    <div class="flex flex-col sm:flex-row items-center gap-5 mt-10 lg:mt-12">
      <a
        href="https://azuremarketplace.microsoft.com"
        class="bg-black text-white font-mono text-[14px] h-[52px] px-8 flex items-center justify-center hover:bg-[#1a1a1a] transition-colors"
        style="box-shadow: 0px 0px 14.7px 5px rgba(255, 255, 255, 0.35) inset;"
      >
        Deploy on Azure Marketplace
      </a>
      <a
        href="/partners"
        class="font-mono text-[14px] text-[#3a3a3a] hover:text-[#020202] inline-flex items-center gap-2 h-[52px] px-2"
      >
        Join Design Partner Program
        <span aria-hidden="true" class="text-[#ee6018]">→</span>
      </a>
    </div>

    {#if latestPost}
      <a
        href="/news/{latestPost.slug}"
        class="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.1em] mt-10 text-[#5C5855] hover:text-[#020202] transition-colors"
      >
        <span class="w-[5px] h-[5px] bg-[#ee6018] rounded-full"></span>
        <span>Latest · {latestPost.title}</span>
        <span class="text-[#ee6018] group-hover:translate-x-0.5 transition-transform">→</span>
      </a>
    {/if}
  </div>
</section>
